import { Link } from "react-router-dom";
import { Pencil, Trash2, Image as ImageIcon, Network, PenLine, Loader2, Check, AlertTriangle, Eye } from "lucide-react";
import { SubjectBadge } from "@/components/SubjectBadge";

const StatusIcon = ({ status }) => {
  if (status === "processing") return <Loader2 className="h-4 w-4 animate-spin" />;
  if (status === "ready") return <Check className="h-4 w-4" />;
  if (status === "error") return <AlertTriangle className="h-4 w-4" />;
  return null;
};

const GenButton = ({ status, icon: Icon, label, onClick, testId, error }) => (
  <button
    onClick={onClick}
    disabled={status === "processing"}
    title={status === "error" ? error : undefined}
    data-testid={testId}
    className={`flex items-center gap-1.5 rounded-full border-2 border-[var(--ink)] px-3 py-1.5 text-xs font-extrabold transition-colors disabled:opacity-70 ${
      status === "ready" ? "bg-emerald-200" : status === "error" ? "bg-red-200" : "bg-white hover:bg-[var(--sun)]"
    }`}
  >
    <Icon className="h-4 w-4" />
    {status === "processing" ? "In corso…" : status === "ready" ? `Rigenera ${label}` : status === "error" ? `Riprova ${label}` : `Genera ${label}`}
    <StatusIcon status={status} />
  </button>
);

export const TeacherTermRow = ({ term, onEdit, onDelete, onComic, onMap, onEditMap }) => (
  <div className="ink-box-sm flex flex-col gap-3 rounded-2xl bg-white p-4 md:flex-row md:items-center" data-testid={`teacher-term-row-${term.id}`}>
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-display text-lg font-bold">{term.word}</span>
        <SubjectBadge subject={term.subject} />
      </div>
      <p className="mt-1 truncate text-sm text-neutral-600">{term.definition}</p>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      <GenButton status={term.comic_status} error={term.comic_error} icon={ImageIcon} label="fumetto" onClick={onComic} testId={`generate-comic-${term.id}`} />
      <GenButton status={term.map_status} error={term.map_error} icon={Network} label="mappa" onClick={onMap} testId={`generate-map-${term.id}`} />
      <button onClick={onEditMap} disabled={term.map_status === "processing"} title="Modifica mappa" aria-label="Modifica mappa" data-testid={`edit-map-${term.id}`} className="flex items-center gap-1 rounded-full border-2 border-[var(--ink)] px-3 py-1.5 text-xs font-extrabold hover:bg-sky-200 disabled:opacity-50"><PenLine className="h-4 w-4" /> Modifica mappa</button>
      <Link to={`/termine/${term.id}`} data-testid={`view-term-${term.id}`} className="rounded-full border-2 border-[var(--ink)] p-2 hover:bg-[var(--paper)]"><Eye className="h-4 w-4" /></Link>
      <button onClick={onEdit} data-testid={`edit-term-${term.id}`} className="rounded-full border-2 border-[var(--ink)] p-2 hover:bg-[var(--sun)]"><Pencil className="h-4 w-4" /></button>
      <button onClick={onDelete} data-testid={`delete-term-${term.id}`} className="rounded-full border-2 border-[var(--ink)] p-2 hover:bg-red-200"><Trash2 className="h-4 w-4" /></button>
    </div>
  </div>
);
